



















































import { Component, Vue } from "vue-property-decorator";
import framework from "@/components/framework.vue"; // @ is an alias to /src
import setting from "./setting";
import qs from "qs";
import moment from "moment";
import { encode, decode } from "js-base64";
import store from "./store";
import skyEyesErrorLog from "./skyEyesErrorLog";

const PARSE_JOS_PARAMETERS_ERROR = "解析 JOS_PARAMETERS 失败";
const INIT_ERROR = "初始化失败";

@Component({
  components: {
    framework,
  },
})
export default class App extends Vue {
  public data() {
    return {
      setting,
      loading: false,
      orderVisible: false,
      initVisible: false,
      info: "",
    };
  }

  public relogin() {
    location.href = "https://cheaper-pack-jdapp.zkyai.com/";
  }

  public async beforeMount() {
    this.init();
  }

  public async init() {
    const loading = (this as any).$loading({
      lock: true,
      text: "请稍等...",
      spinner: "el-icon-loading",
    });
    try {
      await this.getToken();
      this.$data.info = await this.$store.dispatch("getUserInfo");
      // 替换链接
      history.replaceState(null, "", location.href.replace(/\?(.*)/, ""));
      loading.close();
    } catch (error) {
      loading.close();
      skyEyesErrorLog(error.msg || error.message, error);

      // 转换json异常
      if (error.message == PARSE_JOS_PARAMETERS_ERROR) {
        this.$data.orderVisible = true;
        return;
      }

      // 商家未完成初始化以及创库操作，需要进行初始化
      if (
        error.code == 1 &&
        error.sub_code == "need_init" &&
        error.data.shop_name
      ) {
        this.dbInit(error.data.shop_name);
        return;
      }

      // 其他错误
      (this as any).$message.error(error.msg || error.message || error);
    }
  }

  /**
   * 进行商家的数据库初始化
   */
  public async dbInit(shopName: string) {
    const loading = (this as any).$loading({
      lock: true,
      text: "初始化...",
      spinner: "el-icon-loading",
    });
    try {
      const data = await this.$store.dispatch("getLoginInit", {
        activity_id: 14,
        shop_name: shopName,
      });
      localStorage.setItem("token", data.token);
      loading.close();
      this.init(); // 重新进行初始化
    } catch (error) {
      this.$data.initVisible = true;
      loading.close();
      skyEyesErrorLog(error.msg || error.message, error);
      (this as any).$message.error(error.msg || error.message || error);
    }
  }

  public getInfoFromBase64(query: any) {
    try {
      // return {
      //   app_key: "CB69F1769C4B110D010D128E41030C94",
      //   end_date: 1603929600000,
      //   item_code: "E84A334BD8CF47C7594545924E9B27C0",
      //   source: "JM",
      //   user_name: "sop_order",
      //   version_no: 1,
      // };
      const state = (query as any).state.replace(" ", "+");
      return JSON.parse(decode(state)).jos_parameters;
    } catch (error) {
      skyEyesErrorLog(error.msg || error.message, error);
      // base64，格式不对解码报错，未订购，弹窗
      // history.replaceState(null, "", location.href.replace(/\?(.*)/, ""));
      // 测试环境，直接过去
      if (location.host != "cheaper-pack-testjdapp.zkyai.com") {
        throw new Error(PARSE_JOS_PARAMETERS_ERROR);
      }
    }
  }

  /**
   * 获取商家token
   */
  public async getToken() {
    const query: { [x: string]: any } = qs.parse(
      location.search.replace("?", "")
    );
    let token = localStorage.getItem("token");

    if (token) {
      return token;
    }

    // 没有code且不存在state的情况下
    // 邀请用户从服务市场重新进系统
    if (!query.code && !query.state) {
      location.href = "https://fw.jd.com/home/sers.action";
      return new Promise((resolve) => {});
    }

    // 未授权，不带code
    // 获取第三方登录url
    // 没有code但是已经存在
    if (!query.code) {
      const url = await this.$store.dispatch("getLoginUrl", {
        activity_id: 14,
        state: query.state,
      });

      // 此处页面跳出，程序流程挂起不再走后续流程
      location.href = url.login_url;
      return new Promise((resolve) => {});

      // location.href =
      //   "https://open-oauth.jd.com/oauth2/to_login?app_key=6DAEB6171956F553B2B07B1FC1B2826F&redirect_uri=https%3A%2F%2Ftest-s2.zkyai.com%3Factivity_id%3D14&response_type=code&state=1603266880&scope=snsapi_base";
    }

    // 已授权，回调回来
    const jsonData = this.getInfoFromBase64(query) || {};

    // 测试环境，直接过去
    if (location.host != "cheaper-pack-testjdapp.zkyai.com") {
      // 保存应用到期时间
      const endDate = moment(jsonData.end_date).format("YYYY-MM-DD HH:mm:ss");
      const now = moment().format("YYYY-MM-DD HH:mm:ss");

      if (endDate < now) {
        // history.replaceState(null, "", location.href.replace(/\?(.*)/, ""));
        throw PARSE_JOS_PARAMETERS_ERROR;
      }

      await this.$store.dispatch(
        "setExpireDate",
        moment(jsonData.end_date).format("YYYY-MM-DD")
      );
    }

    // 登录获取token
    const data = await this.$store.dispatch("getLoginToken", {
      activity_id: 14,
      code: query.code,
      app_key: jsonData.app_key,
      user_name: jsonData.user_name,
      item_code: jsonData.item_code,
    });
    token = data.token;
    localStorage.setItem("token", data.token);
    return token;
  }
}
